import React, { useState, useEffect, useCallback } from 'react';
import { API_ADDRESS } from './constants.js';

import { Dimmer, Loader, Segment } from 'semantic-ui-react'
import { ConcertCard } from "./ConcertCard";

export function HomeCalendar(props) {
  const [loading, setLoading] = useState(true);
  const [concerts, setConcerts] = useState({});

  const search = useCallback(() => {  
    var url = `${API_ADDRESS}/concerts/next_week`;

    fetch(url)
      .then(function(response) {
        return response.json()
      })
      .then(function(json) {
        setConcerts(json);
        setLoading(false);
      })
      .catch(function(ex) {
        setLoading(false);
        console.log(ex);
      })
  }, []); 

  useEffect(() => { if(loading) { search() } }, [loading, search])

  return (
    <div id="home-calendar">
      <Segment className="browse-table-segment">
        <Dimmer active={loading}>
          <Loader size='large'>Loading</Loader>
        </Dimmer>
      </Segment>
      <h1>Concerts This Week</h1>
      <div className="Cards">
        {Object.keys(concerts).length > 0 && Object.keys(concerts).sort().map(function(date) {
          let concerts_for_date = concerts[date];
          return <ConcertCard key={date} date={date} concerts={concerts_for_date}/>
        })}
        {Object.keys(concerts).length === 0 &&
          <p>An error occurred</p>
        }
      </div>
    </div>
  );
}